/**
 * Chuỗi của tab Kết nối OpenCore (`/rpa/alert-config?tab=connection`) — mới, không có ở native (ADR-0103 mục 5: thay
 * bộ biến `OPENIAP_*`, `OPENCORE_*` mà native đặt một lần cho cả máy chủ). Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaKetNoi = {
  rpaKetNoi: {
    tieuDe: 'Kết nối OpenCore',
    moTa: 'Địa chỉ và JWT dịch vụ mà module dùng để đọc Project, Workflow và gửi lệnh chạy tới OpenCore của tổ chức.',
    chuaKhai: 'Chưa khai',
    chuaKhaiMoTa:
      'Tổ chức chưa khai kết nối OpenCore. Nhập địa chỉ và JWT dịch vụ rồi lưu để các màn Project, Workflow đọc được dữ liệu.',
    capNhatLuc: 'Cập nhật lần cuối {{luc}}',
    url: 'Địa chỉ OpenCore',
    urlGoiY: 'Bắt đầu bằng https://, wss:// hoặc grpcs://.',
    urlMau: 'wss://opencore.example.vn',
    sdkUrl: 'Địa chỉ gửi lệnh chạy',
    sdkUrlGoiY: 'Tuỳ chọn. Để trống thì gửi lệnh qua địa chỉ OpenCore ở trên.',
    jwt: 'JWT dịch vụ',
    jwtGoiY: 'Chỉ ghi: sau khi lưu, JWT không hiện lại ở đây.',
    jwtDaLuu: 'Đã lưu JWT',
    jwtChuaCo: 'Chưa có JWT',
    jwtGiuNguyen: 'Để trống để giữ JWT đang dùng',
    jwtNhap: 'Dán JWT dịch vụ',
    goJwt: 'Gỡ JWT',
    goJwtTieuDe: 'Gỡ JWT dịch vụ?',
    goJwtThan:
      'Module sẽ không đọc được OpenCore cho tới khi có JWT mới: màn Project, Workflow và lệnh chạy ngừng hoạt động. Thao tác này không hoàn tác được.',
    daGoJwt: 'Đã gỡ JWT dịch vụ.',
    nangCao: 'Tuỳ chọn nâng cao',
    nangCaoMoTa: 'Thường giữ nguyên giá trị mặc định.',
    workflowsCollection: 'Collection Workflow',
    robotsCollection: 'Collection Robot (User)',
    collectionGoiY: 'Chỉ gồm chữ, số, gạch dưới.',
    licenseRole: 'Role License',
    licenseRoleGoiY: 'Role OpenCore đánh dấu User được cấp License RPA.',
    projectRolePrefix: 'Tiền tố role Project',
    projectRolePrefixGoiY: 'Role OpenCore của từng Project bắt đầu bằng tiền tố này.',
    projectWorkflowRights: 'Quyền Workflow trên Project',
    projectProRights: 'Quyền Pro trên Project',
    quyenGoiY: 'Bit quyền của OpenCore, số nguyên từ 0 đến 65535.',
    rpcTimeoutSeconds: 'Thời gian chờ lệnh chạy (giây)',
    rpcTimeoutGoiY: 'Từ 30 đến 86.400 giây.',
    maxRetry: 'Số lần thử lại',
    maxRetryGoiY: 'Từ 0 đến 10 lần.',
    licenseSyncIntervalMinutes: 'Chu kỳ đồng bộ License (phút)',
    licenseSyncGoiY: 'Từ 1 đến 1.440 phút.',
    enabled: 'Bật kết nối',
    enabledGoiY: 'Tắt thì mọi màn đọc OpenCore báo kết nối đang tắt, Robot không nhận lệnh chạy mới.',
    loiBatBuoc: 'Không được để trống.',
    loiUrl: 'Địa chỉ bắt đầu bằng https://, wss:// hoặc grpcs://, ví dụ wss://opencore.example.vn.',
    loiCanJwt: 'Nhập JWT dịch vụ: thiếu JWT thì module không đọc được OpenCore.',
    loiJwtDai: 'JWT dài quá 8.000 ký tự. Kiểm tra lại chuỗi vừa dán.',
    loiCollection: 'Chỉ gồm chữ, số, gạch dưới.',
    loiRole: 'Chỉ gồm chữ, số, dấu chấm, gạch.',
    loiKhoang: 'Nhập số nguyên từ {{min}} đến {{max}}.',
    luu: 'Lưu kết nối',
    hoanTac: 'Hoàn tác',
    daLuu: 'Đã lưu kết nối OpenCore.',
    kiemTra: 'Kiểm tra kết nối',
    dangKiem: 'Đang kiểm tra...',
    kiemDuoc: 'Kết nối được OpenCore {{url}}.',
    kiemTruocLuu: 'Lệnh kiểm tra dùng kết nối đã lưu. Lưu thay đổi trước rồi kiểm tra.',
    chiXem: 'Bạn chỉ xem được kết nối. Cần quyền {{quyen}} để sửa.',
  },
} as const;
